var _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlanetLg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 2045,
    height: 2048,
    viewBox: "0 0 2045 2048",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.43,
    filter: "url(#filter0_f)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 1022.26,
    cy: 1023.64,
    rx: 490.899,
    ry: 531.795,
    transform: "rotate(136.36 1022.26 1023.64)",
    fill: "#2E6DF6"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1375.91 767.181C1537 943.477 1524.67 1216.98 1348.37 1378.07C1172.08 1539.16 898.571 1526.83 737.483 1350.53C576.394 1174.24 588.723 900.733 765.019 739.644C941.316 578.555 1214.82 590.884 1375.91 767.181Z",
    fill: "url(#paint0_linear)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M853.028 994.626C877.813 1021.75 875.92 1063.82 848.799 1088.61C821.679 1113.39 779.601 1111.5 754.816 1084.38C730.031 1057.26 731.924 1015.18 759.044 990.398C786.164 965.613 828.242 967.506 853.028 994.626Z",
    fill: "url(#paint1_linear)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1180.9 696.997C1192.06 703.558 1194.68 716.214 1186.75 725.265C1178.82 734.316 1163.34 736.335 1152.17 729.774C1141.01 723.213 1138.39 710.557 1146.32 701.506C1154.25 692.455 1169.73 690.436 1180.9 696.997Z",
    fill: "url(#paint2_linear)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1425.65 941.983C1439.59 942.081 1450.77 957.79 1450.64 977.071C1450.5 996.351 1439.09 1011.9 1425.16 1011.8C1411.22 1011.71 1400.03 995.996 1400.17 976.716C1400.31 957.436 1411.71 941.885 1425.65 941.983Z",
    fill: "url(#paint3_linear)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M910.469 668.376C913.664 675.13 902.126 687.29 884.698 695.536C867.269 703.782 850.55 704.993 847.355 698.239C844.159 691.485 855.697 679.325 873.126 671.079C890.554 662.832 907.273 661.622 910.469 668.376Z",
    fill: "url(#paint4_linear)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M1278.42 1245.82C1302.8 1288.63 1281.39 1346.78 1230.61 1375.71C1179.82 1404.64 1118.88 1393.39 1094.5 1350.58C1070.12 1307.78 1091.53 1249.62 1142.31 1220.7C1193.1 1191.77 1254.03 1203.02 1278.42 1245.82Z",
    fill: "url(#paint5_linear)",
    fillOpacity: 0.66
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M1132.2 971.705C1139.6 993.443 1127.97 1017.06 1106.24 1024.46C1084.5 1031.86 1060.88 1020.23 1053.48 998.495C1046.08 976.757 1057.71 953.137 1079.45 945.74C1101.19 938.342 1124.8 949.967 1132.2 971.705Z",
    fill: "#003D6E"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M1009.63 714.772C1014.06 727.815 1000.04 744.385 978.303 751.783C956.565 759.181 935.344 754.604 930.905 741.562C926.467 728.519 940.491 711.948 962.229 704.551C983.967 697.153 1005.19 701.729 1009.63 714.772Z",
    fill: "#003D6E"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M1411.38 1133.72C1423.3 1140.63 1423.63 1162.33 1412.11 1182.2C1400.59 1202.06 1381.6 1212.57 1369.68 1205.66C1357.76 1198.75 1357.43 1177.04 1368.95 1157.18C1380.46 1137.31 1399.46 1126.81 1411.38 1133.72Z",
    fill: "#011A30"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f",
    x: 0,
    y: 0,
    width: 2044.53,
    height: 2047.27,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 150,
    result: "effect1_foregroundBlur"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 765.02,
    y1: 739.645,
    x2: 1348.37,
    y2: 1378.07,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0066B9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 759.044,
    y1: 990.398,
    x2: 848.799,
    y2: 1088.61,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0066B9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 1146.32,
    y1: 701.505,
    x2: 1180.96,
    y2: 731.866,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B4A86"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear",
    x1: 1400.17,
    y1: 976.716,
    x2: 1450.64,
    y2: 977.071,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#15325B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear",
    x1: 873.126,
    y1: 671.078,
    x2: 884.698,
    y2: 695.535,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035FAB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear",
    x1: 1142.31,
    y1: 1220.7,
    x2: 1230.61,
    y2: 1375.71,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#150305"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#113D6E"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlanetLg);
export default __webpack_public_path__ + "static/media/planet-lg.c8e5f2e4f3ee03a65bac4333002b6d79.svg";
export { ForwardRef as ReactComponent };